import { extractMessageParams, randomString } from '../helpers';
import { createNotificationProxy } from '.';
const defaultOptions = {
  intent: 'info',
  title: '',
  message: '',
  timeout: 5000,
  dismissible: true
};
export const notifyInfo = message => {
  const options = {
    ...defaultOptions,
    id: randomString(),
    ...extractMessageParams(message),
    intent: 'info'
  };
  return createNotificationProxy(options);
};

// alias
export const notify = notifyInfo;
export const notifySuccess = message => {
  const options = {
    ...defaultOptions,
    id: randomString(),
    ...extractMessageParams(message),
    intent: 'success'
  };
  return createNotificationProxy(options);
};
export const notifyProgress = message => {
  const options = {
    ...defaultOptions,
    id: randomString(),
    ...extractMessageParams(message),
    intent: 'progress'
  };
  return createNotificationProxy(options);
};
export const notifyWarning = message => {
  const options = {
    ...defaultOptions,
    id: randomString(),
    timeout: 8000,
    ...extractMessageParams(message),
    intent: 'warning'
  };
  return createNotificationProxy(options);
};
export const notifyDanger = message => {
  const options = {
    ...defaultOptions,
    id: randomString(),
    timeout: 8000,
    ...extractMessageParams(message),
    intent: 'danger'
  };
  return createNotificationProxy(options);
};